import { render, staticRenderFns } from "./userorder.vue?vue&type=template&id=0efcedbc&scoped=true&"
import script from "./userorder.vue?vue&type=script&lang=js&"
export * from "./userorder.vue?vue&type=script&lang=js&"
import style0 from "./userorder.vue?vue&type=style&index=0&lang=css&"
import style1 from "./userorder.vue?vue&type=style&index=1&id=0efcedbc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0efcedbc",
  null
  
)

export default component.exports